import { Component, Input } from '@angular/core';
import { NavItemComponent } from './nav-item/nav-item.component';

@Component({
    selector: 'CDMS-Portal-U2-main-sidenav',
    templateUrl: './main-sidenav.component.html',
    styleUrls: ['./main-sidenav.component.scss'],
    imports: [NavItemComponent]
})
export class MainSidenavComponent {

  @Input() parentScreens: any = [];

  constructor() {}
}
